// extracted by mini-css-extract-plugin
module.exports = {"root":"SettingsMenuItem__root","hoverable":"SettingsMenuItem__hoverable","active":"SettingsMenuItem__active","children":"SettingsMenuItem__children","icon":"SettingsMenuItem__icon","content":"SettingsMenuItem__content"};
    if(module.hot) {
      // 1790535734514
      var cssReload = require("/var/lib/jenkins/workspace/Player_master/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  